import { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'

import './home.css'
import '../components/Triangles.css'

import AOS from 'aos';

import 'aos/dist/aos.css';

import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Home = () => {
  const [isMobileMenuOpen] = useState(false)
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const [contactTurnstileToken, setContactTurnstileToken] = useState("");
  const [contactCaptchaError, setContactCaptchaError] = useState("");
  const contactTurnstileRef = useRef(null);
  const contactWidgetIdRef = useRef(null);
  const handleContactSubmit = async () => {

    console.log("HANDLE PARTITO");
    console.log({ name, email, message });

    if (!name || !email || !message) {
      alert("Compila tutti i campi");
      return;
    }

    if (!privacyChecked) {
      alert("Devi accettare la privacy");
      return;
    }

    if (!contactTurnstileToken) {
      setContactCaptchaError("Completa il controllo anti-bot.");
      return;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          nome: name,
          email: email,
          messaggio: message,
          turnstileToken: contactTurnstileToken,
          privacyConsent: privacyChecked,
        })
      });

      console.log("STATUS:", res.status);

      const data = await res.json();
      console.log("DATA:", data);

      if (data.success) {
        alert("Messaggio inviato!");
        setName("");
        setEmail("");
        setMessage("");
        setContactTurnstileToken("");
        if (window.turnstile && contactWidgetIdRef.current !== null) {
          window.turnstile.reset(contactWidgetIdRef.current);
        }
      } else {
        alert("Errore nell'invio");
      }
    } catch (err) {
      console.error("CONTACT ERROR:", err);
      alert("Errore di connessione");
    }
  };
  useEffect(() => {
    AOS.init({
      duration: 3000,
      once: true,
      easing: "ease-out-cubic"
    });
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : ''
    return () => { document.body.style.overflow = '' }
  }, [isMobileMenuOpen])

  useEffect(() => {
    const loadTurnstile = () => {
      if (
          window.turnstile &&
          contactTurnstileRef.current &&
          contactWidgetIdRef.current === null
      ) {
        contactWidgetIdRef.current = window.turnstile.render(contactTurnstileRef.current, {
          sitekey: process.env.REACT_APP_TURNSTILE_SITE_KEY,
          theme: "light",
          callback: (token) => {
            setContactTurnstileToken(token);
            setContactCaptchaError("");
          },
          "expired-callback": () => {
            setContactTurnstileToken("");
            setContactCaptchaError("Verifica scaduta. Rifalla.");
          },
          "error-callback": () => {
            setContactTurnstileToken("");
            setContactCaptchaError("Errore CAPTCHA. Ricarica la pagina.");
          },
        });
      }
    };

    if (!document.querySelector('script[src*="challenges.cloudflare.com/turnstile"]')) {
      const script = document.createElement("script");
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.async = true;
      script.defer = true;
      script.onload = loadTurnstile;
      document.body.appendChild(script);
    } else {
      loadTurnstile();
    }

    return () => {
      if (window.turnstile && contactWidgetIdRef.current !== null) {
        window.turnstile.remove(contactWidgetIdRef.current);
        contactWidgetIdRef.current = null;
      }
    };
  }, []);

  return (
    <div className="home-container">
      <Helmet>
        <title>Home</title>
        <meta property="og:Home" content="Landing Page" />
      </Helmet>
      <Navbar />
      <div className="hero">
        <div className="hero-content-container">
          <div className="hero-text">
            <h1 className="heading-title ">ARENA CHAMPIONSHIP</h1>
            <span className="hero-text">
              introduce in Italia un formato di combattimento ancora raro:
              un’arena quadrata con pareti inclinate progettate per mantenere l’azione sempre viva.

              Una struttura costruita dall'organizzazione per offrire incontri più dinamici,
              continui e spettacolari rispetto alle superfici tradizionali.
            </span>
          </div>
        </div>
      </div>
      <div  className="features-section">
        <div className="features-heading-container">
          <h2 className="heading Section-Heading">
            COS&apos;HA DI SPECIALE IL NOSTRO EVENTO?
          </h2>
        </div>
        <div className="features-cards-container">
          <div className="features-card" data-aos="fade-up" data-aos-delay="100">
            <div className="medal-icon-container">
              <svg height="24" width="24" viewBox="0 0 24 24">
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                >
                  <path d="M14.272 10.445L18 2m-8.684 8.632L5 2m7.762 8.048L8.835 2m5.525 0l-1.04 2.5M6 16a6 6 0 1 0 12 0a6 6 0 0 0-12 0"></path>
                  <path d="m10.5 15l2-1.5v5"></path>
                </g>
              </svg>
            </div>
            <div className="card-section-cont">
              <span className="features-card-title Card-Heading">
                LA COMPETIZIONE
              </span>
              <span className="card-text Card-Text">
                ARENA Championship è una competizione dedicata agli sport da combattimento,
                dove tecnica, disciplina e spettacolo si incontrano.

                Atleti provenienti da diverse discipline si confrontano in un contesto
                organizzato, sicuro e regolamentato, con l'obiettivo di valorizzare
                il talento e lo spirito delle arti marziali.
              </span>
            </div>
          </div>
          <div className="features-card" data-aos="fade-up" data-aos-delay="500">
            <div className="running-man-icon-container">
              <svg height="24" width="24" viewBox="0 0 24 24">
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                >
                  <path d="M15 7a2 2 0 1 0 0-4a2 2 0 0 0 0 4m-2.387 1.267l-3.308 4.135l4.135 4.135l-2.067 4.55"></path>
                  <path d="m6.41 9.508l3.387-3.309l2.816 2.068l2.895 3.308h3.722M8.892 15.71l-1.241.827H4.343"></path>
                </g>
              </svg>
            </div>
            <div className="card-section-cont">
              <span className="features-card-title Card-Heading">
                PARTECIPAZIONE
              </span>
              <span className="card-text Card-Text">
                Sei un atleta o rappresenti una società sportiva?

                Attraverso la sezione iscrizioni puoi registrare la tua partecipazione
                all'evento e inviare i dati necessari per prendere parte alla competizione.

                Le iscrizioni sono aperte fino alla data indicata nel bando ufficiale.
              </span>
            </div>
          </div>
          <div className="features-card" data-aos="fade-up" data-aos-delay="800">
            <div className="megaphone-icon-container">
              <svg height="24" width="24" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M17.923 12.5v-1h3.23v1zm1.085 6.462l-2.585-1.939l.623-.792l2.585 1.938zm-2.039-11.27l-.623-.792l2.585-1.939l.623.793zM5.5 17.962v-3.808H4.462q-.671 0-1.144-.472t-.472-1.143v-1.077q0-.671.472-1.144t1.143-.472h3.731L12.154 7.5v9l-3.962-2.346H6.5v3.808zm5.654-3.243V9.281l-2.681 1.565H4.461q-.23 0-.423.193t-.192.423v1.077q0 .23.192.423t.423.192h4.012zm2.769.17V9.112q.502.465.809 1.222T15.038 12t-.306 1.666t-.809 1.222M7.5 12"
                ></path>
              </svg>
            </div>
            <div className="card-section-cont">
              <span className="features-card-title Card-Heading">
                REGOLAMENTO
              </span>
              <span className="card-text Card-Text">
                Il regolamento ARENA definisce le regole tecniche e organizzative
                che garantiscono sicurezza, equità e corretto svolgimento degli incontri.

                Include requisiti per la partecipazione, categorie, durata dei match,
                tecniche consentite e modalità di valutazione dei combattimenti.
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="gallery section-padding" data-aos="fade-down">
        <div className="gallery-container Gallery-container">
          <div className="gallery-titles-container">
            <h2 className="heading Section-Heading">ALCUNE FOTO</h2>
            <span className="gallery-subtitle subtitle-gallery-prop">
              Ecco come si presenta la nostra arena
            </span>
          </div>
          <div className="home-container3">
            <div className="scroll-container">
              <img
                alt="Image 1 Alt Text"
                src={"images/pit_event-1500w.jpeg"}
                className="gallery-image img-ratio"
              />
              <img
                alt="Image 2 Alt Text"
                src={"images/pit-1500w.jpeg"}
                className="gallery-image img-ratio"
              />
              <img
                alt="Image 3 Alt Text"
                src={"images/pit(2)-1500w.jpeg"}
                className="gallery-image img-ratio"
              />
            </div>
          </div>
        </div>
      </div>
      <div id="process" className="utils-cont shadow" data-aos="slide-up" data-aos-duration="2000">
        <div className="utils-heading-container">
          <h1 className="heading-title Section-Heading">INFORMAZIONI UTILI</h1>
        </div>
        <div className="cards-container">
          <div className="service-card" data-aos="slide-left" data-aos-delay="500">
            <h3 className="util-cards-title Card-Heading">Regolamento</h3>
            <span className="card2-text Card-Text">
              Per garantire sicurezza, equità e rispetto sportivo,
              ogni incontro segue il regolamento ufficiale ARENA.

              Il documento definisce categorie, tecniche consentite,
              durata dei match e criteri di valutazione degli incontri.
            </span>
            <a href={"/rules"} className="Anchor">Leggi il regolamento</a>
            <img
              src={"assets/sagoma(2)-200w.png"}
              alt="image"
              className="sagoma1"
            />
          </div>
          <div className="service-card" data-aos="slide-right" data-aos-delay="500">
            <h3 className="util-cards-title Card-Heading">Chi siamo?</h3>
            <span className="card2-text Card-Text">
              ARENA Championship è una promotion dedicata agli sport da combattimento
              che unisce disciplina marziale, spettacolo e competizione.

              L'obiettivo è creare un evento dove atleti di diverse categorie
              possano confrontarsi in un contesto organizzato, sicuro e regolamentato.
            </span>
            <a href={"/aboutUs"} className="Anchor">Scopri chi organizza l'evento</a>
            <img src={"assets/sagoma-200h.png"} alt="image" className="sagoma2" />
          </div>
        </div>
      </div>
      <div className="get-in-touch-wrap">
        <div className="tri tri-left" />
        <div className="tri tri-right" />
        <div className="get-in-touch-container">

          <h2 className="heading Section-Heading">CONTATTACI!</h2>
          <div className="form-content-cont">
            <div className="form-container">
              <input
                type="text"
                required
                placeholder="Name"
                className="textbox input"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <input
                  type="email"
                  placeholder="E-mail"
                  className="textbox input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
              />
              <textarea
                  placeholder="Your Message"
                  className="message-textbox textarea"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
              ></textarea>
              <label className="full-width mt-2 flex items-start gap-3 rounded-xl bg-white/5 p-4 text-sm text-white">
                <input
                    name="privacyConsent"
                    type="checkbox"
                    checked={privacyChecked}
                    onChange={(e) => setPrivacyChecked(e.target.checked)}
                    className="mt-1 h-4 w-4 rounded bg-transparent accent-red-500"
                />
                <span className="leading-5 text-gray-500">
                        Acconsento al trattamento dei dati personali ai fini della gestione
                        dell'iscrizione all'evento, ai sensi della normativa privacy vigente.
                    </span>
              </label>
              <div className="full-width mt-2 flex flex-col items-center">
                <div className="flex justify-center w-full">
                  <div ref={contactTurnstileRef}></div>
                </div>

                {contactCaptchaError && (
                    <p className="mt-2 text-sm text-red-400 text-center">{contactCaptchaError}</p>
                )}
              </div>
                <button className="send-message button Anchor"
                        onClick={handleContactSubmit}
                        type="button"
                >
                  INVIA
                </button>
              </div>
              <div className="locations-container">
                <div className="location">
                  <div className="adress-cont">
                    <svg viewBox="0 0 1024 1024" className="adress-icon">
                      <path d="M512 0c-176.732 0-320 143.268-320 320 0 320 320 704 320 704s320-384 320-704c0-176.732-143.27-320-320-320zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z"></path>
                    </svg>
                    <span className="Section-Text">Indirizzo: Via Vercelli 7, Cantalupo MI</span>
                  </div>
                  <div className="email-cont">
                    <svg viewBox="0 0 1024 1024" className="email-icon">
                      <path d="M854 342v-86l-342 214-342-214v86l342 212zM854 170q34 0 59 26t25 60v512q0 34-25 60t-59 26h-684q-34 0-59-26t-25-60v-512q0-34 25-60t59-26h684z"></path>
                    </svg>
                    <span className="Section-Text">
                      E-mail: arenachampionship.event@gmail.com
                    </span>
                  </div>
                  <div className="phone-cont">
                    <svg
                      viewBox="0 0 804.5714285714286 1024"
                      className="tel-icon"
                    >
                      <path d="M804.571 708.571c0 20.571-9.143 60.571-17.714 79.429-12 28-44 46.286-69.714 60.571-33.714 18.286-68 29.143-106.286 29.143-53.143 0-101.143-21.714-149.714-39.429-34.857-12.571-68.571-28-100-47.429-97.143-60-214.286-177.143-274.286-274.286-19.429-31.429-34.857-65.143-47.429-100-17.714-48.571-39.429-96.571-39.429-149.714 0-38.286 10.857-72.571 29.143-106.286 14.286-25.714 32.571-57.714 60.571-69.714 18.857-8.571 58.857-17.714 79.429-17.714 4 0 8 0 12 1.714 12 4 24.571 32 30.286 43.429 18.286 32.571 36 65.714 54.857 97.714 9.143 14.857 26.286 33.143 26.286 50.857 0 34.857-103.429 85.714-103.429 116.571 0 15.429 14.286 35.429 22.286 49.143 57.714 104 129.714 176 233.714 233.714 13.714 8 33.714 22.286 49.143 22.286 30.857 0 81.714-103.429 116.571-103.429 17.714 0 36 17.143 50.857 26.286 32 18.857 65.143 36.571 97.714 54.857 11.429 5.714 39.429 18.286 43.429 30.286 1.714 4 1.714 8 1.714 12z"></path>
                    </svg>
                    <span>Numero di telefono: +39 346 770 0457</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
     <Footer />
    </div>
  )
}

export default Home
